import * as React from 'react';
import { Typography } from '@material-ui/core';
import { Redirect, useHistory } from 'react-router-dom';
import cn from 'classnames';
import { Profile, IdentityConfirmationOption } from '../../generated/graphql';
import IconDialog from '../../components/IconDialog/IconDialog';
import { useIdentificationConfirmationPhoneCode } from './utils/useIdentificationConfirmationPhoneCode';

import RenderText from '../../dictionaries/RenderText';
import IdentificationConfirmationPhoneCodeVerification from './IdentificationConfirmationPhoneCodeVerification';
import { IdentificationConfirmationStyles } from './IdentificationConfirmationStyles';

interface IdConfPhoneCodeProps {
  baseClasses: IdentificationConfirmationStyles;
  id?: string | number;
  parentUrl: string;
  redirectUrl: string;
  profile?: Omit<Profile, 'financialSituation'>;
  option: IdentityConfirmationOption;
  refetchConfirmationOptions?: () => Promise<any>;
  setShowSnackbarPhoneError?: (show: boolean) => void;
}

const IdentificationConfirmationPhoneCode: React.FC<IdConfPhoneCodeProps> = (props) => {
  const {
    baseClasses,
    parentUrl,
    profile,
    option,
    refetchConfirmationOptions,
    setShowSnackbarPhoneError,
  } = props;
  const history = useHistory();

  // Redirigir si los intentos se agotaron
  React.useEffect(() => {
    if (option?.attemptsExhausted) {
      if (setShowSnackbarPhoneError) setShowSnackbarPhoneError(true);
      history.push(parentUrl);
    }
  }, [ option?.attemptsExhausted, history, parentUrl, setShowSnackbarPhoneError ]);

  const useIdResult = useIdentificationConfirmationPhoneCode({
    profile,
    parentUrl,
    refetchConfirmationOptions,
  });
  const { isValid, loading, digits } = useIdResult;

  if (!isValid) return <Redirect to={parentUrl} />;

  return (
    <>
      <Typography className={cn(baseClasses.title, 'mb-2')}>
        <RenderText textKey="validation_phone_msgOption_title" />
      </Typography>
      <Typography className={cn(baseClasses.text, 'mt-2 mb-3')}>
        {digits && <RenderText textKey="validation_phone_msgOption_registered_description" context={{ phone: digits }} />}
      </Typography>

      <IdentificationConfirmationPhoneCodeVerification
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...useIdResult}
        baseClasses={baseClasses}
        option={option}
      />

      <IconDialog
        icon="loading"
        rotating
        open={loading}
      >
        <Typography variant="h3"><RenderText textKey="validation_phone_msgOption_loading" /></Typography>
      </IconDialog>
    </>
  );
};

export default IdentificationConfirmationPhoneCode;
